var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.61 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#051d27;}.cls-2{fill:#06e403;}.cls-3{fill:#05a902;}.cls-4{fill:#01e501;}.cls-5{fill:#00d503;}.cls-6{fill:#09fd02;}.cls-7{fill:#019902;}.cls-8{fill:#01e300;}.cls-9{fill:#57fd7f;}.cls-10{fill:#03be02;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3Artboard 710") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,70h0a2.75,2.75,0,0,1-2-.92L.7,29.62a2.76,2.76,0,0,1-.31-3.25L11,8.55a2.76,2.76,0,0,1,1.27-1.12L23.12,2.71a2.77,2.77,0,0,1,.62-.19L37.74,0a3.09,3.09,0,0,1,1,0L52.62,2.52a3.38,3.38,0,0,1,.62.18L64.42,7.58l.13,0h0a2.69,2.69,0,0,1,.65.45h0a3,3,0,0,1,.4.47h0l.09.14L76.23,26.6a2.73,2.73,0,0,1-.34,3.25L40.06,69.1A2.76,2.76,0,0,1,38,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.13,18.75c-2.64,7-1.74,13.65,2.09,20,6.74-3.1,11.83-8.4,14.44-17C33,18.93,27.49,17.74,22.13,18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.86,28,63.33,10.1c-6.26,1.19-8.79,4.41-9,8.91C58.67,25.3,65.39,28,73.86,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.49,21.94c.15,7.77,4.2,13.31,12.19,16.57l.07,0c4.5-5.59,5.9-12,3.62-19.47C48.26,16.08,42.9,16.72,38.49,21.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.22,38.76q13.19,6.43,26.46-.25L38.49,21.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.22,38.76c1,9.17,6.29,18.72,13.81,28.49,7.4-9,12.5-18.4,12.72-28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.75,38.48,38,67.25,73.86,28C64.47,28.32,56.19,30.75,50.75,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2.75,27.79,38,67.25,24.22,38.76C20.11,31,11.89,28.8,2.75,27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.39,10,2.75,27.79c9.33,1.22,16.19-1.21,19.54-8.88C24.57,13.79,21.22,11,13.39,10Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2.75 27.79 24.22 38.76 22.29 18.91 2.75 27.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "52.14 5.23 38.22 2.75 24.22 5.23 13.39 9.96 22.29 18.91 38.49 21.94 54.37 19.01 63.33 10.1 52.14 5.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "50.74 38.48 73.86 27.99 54.37 19.01 50.74 38.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "13.89 10.83 24.37 5.43 38.22 2.75 24.22 5.23 13.39 9.96 13.89 10.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "22.29 18.91 24.22 38.76 21.1 19.05 22.29 18.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "22.29 18.91 38.49 21.94 38.03 22.48 22.29 18.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "63.33 10.1 53 19.28 54.37 19.01 63.33 10.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.175b0f75cd839c416f6a1b902012d771.svg";
export { ForwardRef as ReactComponent };